import tracking from 'dibs-tracking';

const SIDEBAR = 'SIDEBAR';
const SELLER_GRID = 'SELLER_GRID';
const SIMILAR_ITEM_GRID = 'SIMILAR_ITEM_GRID';
const SEARCH_BROWSE = 'SEARCH_BROWSE';
const ZOOM_MODAL = 'ZOOM_MODAL';
const VIEW_IN_ROOM = 'VIEW_IN_ROOM';

export const locations = {
    SIDEBAR,
    SELLER_GRID,
    SIMILAR_ITEM_GRID,
    SEARCH_BROWSE,
    ZOOM_MODAL,
    VIEW_IN_ROOM,
};

export const authLabels = {
    SIDEBAR: 'save item - product page',
    SELLER_GRID: 'save item - product page - more from dealer',
    SIMILAR_ITEM_GRID: 'save item - product page - you may also like',
};

const heartLabels = {
    SIDEBAR: 'PDP',
    SELLER_GRID: 'PDP - more from dealer',
    SIMILAR_ITEM_GRID: 'PDP - you may also like',
    SEARCH_BROWSE: 'SB',
    VIEW_IN_ROOM: 'view in room',
};

function trackHeartEvent(location, action) {
    tracking.trackEvent({
        action,
        category: 'item favoriting',
        label: heartLabels[location],
    });
}

export const trackHeartFavorited = location => trackHeartEvent(location, 'item added');
export const trackHeartUnfavorited = location => trackHeartEvent(location, 'item removed');

function trackFolderEvent(action, noteIncluded, itemPk) {
    tracking.trackEvent({
        action,
        label: 'pdp',
        category: 'item favoriting',
        value: noteIncluded ? 1 : 0,
        additional: itemPk ? { itemPk } : {},
    });
}

const trackFolderClick = () => trackFolderEvent('item favoriting folder clicked');
const trackItemRemoved = () => trackFolderEvent('item removed from folder');
const trackItemAdded = (noteIncluded, itemPk) =>
    trackFolderEvent('item added into folder', noteIncluded, itemPk);
const trackFolderCreated = noteIncluded =>
    trackFolderEvent('item favoriting folder created', noteIncluded);

export const folderTrackingHooks = {
    trackFolderClick,
    trackItemRemoved,
    trackItemAdded,
    trackFolderCreated,
};
